import { withTranslation } from "next-i18next";
import { usePagination } from "react-instantsearch";

function CatalogSearchResults({ t }) {
  const { nbHits } = usePagination();

  if (!nbHits) return <></>;

  return (
    <p className="mb-2 text-gray font-size-sm">{t("catalog:filters.results", { count: nbHits })}</p>
  );
}

export default withTranslation("catalog")(CatalogSearchResults);
